import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Apps from '@material-ui/icons/Apps';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import Grid from '@material-ui/core/Grid';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

const useStyles = theme => ({
  toggleContainer: {
    margin: theme.spacing(1, 0),
  },
  iconView : {
    color: "gray !important"
  }
});

class ToggleButtonCustom extends Component {

    state = {
        alignment: 'left'
    }

    handleAlignment = (event, alignment) => {
        if (alignment !== null) {
            this.setState({ alignment })
            this.props.onChange(alignment);
        }
    }
  
    render() {
        let { classes } = this.props;
        let { alignment } = this.state;

        return (
            <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                <div className={classes.toggleContainer}>
                    <ToggleButtonGroup
                    value={alignment}
                    exclusive
                    onChange={this.handleAlignment}
                    aria-label="text alignment"
                    >
                    <ToggleButton value="left" aria-label="left aligned">
                        <Apps className={classes.iconView}/>
                    </ToggleButton>
                    <ToggleButton value="right" aria-label="right aligned">
                        <FormatListBulletedIcon className={classes.iconView}/>
                    </ToggleButton>
                    </ToggleButtonGroup>
                </div>
                </Grid>
            </Grid>
        );
    }  
}

export default withStyles(useStyles)(ToggleButtonCustom);